import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import LitImage from '../../components/images/LitImage';
import EmbeddedVideo from '../EmbeddedVideo';

const SpecialAboutFibre = ({ locationTemplate }) => {
  const data = imageQuery();

  return (
    <>
      <div className="special-about-fibre">
        <div className="row special-about-fibre-container">
          <h3 className="text-center col-md-12 special-about-fibre-header">
            What’s so special about <strong>Full Fibre?</strong>
          </h3>
          <div className="embedded-video-col pb-5">
            <EmbeddedVideo youtubeUrl="https://www.youtube.com/embed/Yh5q-BUgJng" />
          </div>
          <div className="col-md-6 text-center special-about-fibre-left">
            <LitImage
              image={data.iStockOne}
              alt="Icon"
              style={{ width: '100%', height: '341px', objectFit: 'fill' }}
              loading="lazy"
            />
            <h5 className="text-center">
              Quicker. More reliable.
              <br /> Better value. The full package.
            </h5>
            <LitImage
              image={data.atom}
              alt="Icon"
              style={{ width: '100%', height: '60px', objectFit: 'fill' }}
              loading="lazy"
            />
            <p className="text-left">
              Fibre to the premises (FTTP) uses fibre optic cables connected
              directly from the exchange into your home for rock solid
              connections.
            </p>
            <LitImage
              image={data.oneGBSpeeds}
              alt="Icon"
              style={{ width: '100%', height: '60px', objectFit: 'fill' }}
              loading="lazy"
            />
            <p className="text-left">
              Delivers speeds of up to 1,000Mb – which could be up to 18x faster
              than UK average speed**** and 5x more more reliable than
              "standard" fibre.***
            </p>
          </div>
          <div className="col-md-6 text-center special-about-fibre-right">
            <LitImage
              image={data.iStockTwo}
              alt="Icon"
              style={{ width: '100%', height: '341px', objectFit: 'fill' }}
              loading="lazy"
            />
            <h5 className="text-center">
              Why traditional fibre
              <br /> is yesterday’s news
            </h5>
            <LitImage
              image={data.speedMeter}
              alt="Icon"
              style={{ width: '100%', height: '60px', objectFit: 'fill' }}
              loading="lazy"
            />
            <p className="text-left">
              Your current provider probably delivers their ‘fibre’ broadband
              using fibre to the cabinet (FTTC), shown in the diagram below,
              with the copper cables greatly reducing your speed and
              reliability.
            </p>
            <LitImage
              image={data.arrows}
              alt="Icon"
              style={{ width: '100%', height: '60px', objectFit: 'fill' }}
              loading="lazy"
            />
            <p className="text-left">
              Not built for modern needs or modern homes – speeds are slower,
              with no symmetry between downloads and uploads.
            </p>
            <LitImage
              image={data.mapPoint}
              alt="Icon"
              style={{ width: '100%', height: '60px', objectFit: 'fill' }}
              loading="lazy"
            />
            <p className="text-left">
              The speed you actually get depends on where you live.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecialAboutFibre;

const imageQuery = () =>
  useStaticQuery(graphql`
    {
      iStockOne: file(
        relativePath: { eq: "location-images/iStock-11754686.jpg" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      iStockTwo: file(
        relativePath: { eq: "location-images/iStock-13303013.jpg" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      atom: file(relativePath: { eq: "location-images/icons/atom.svg" }) {
        name
        relativePath
        extension
        publicURL
      }
      mapPoint: file(
        relativePath: { eq: "location-images/icons/mapPoint.svg" }
      ) {
        name
        relativePath
        extension
        publicURL
      }
      speedMeter: file(
        relativePath: { eq: "location-images/icons/speedMeter.svg" }
      ) {
        name
        relativePath
        extension
        publicURL
      }
      arrows: file(relativePath: { eq: "location-images/icons/arrows.svg" }) {
        name
        relativePath
        extension
        publicURL
      }
      oneGBSpeeds: file(
        relativePath: { eq: "location-images/icons/oneGBSpeeds.svg" }
      ) {
        name
        relativePath
        extension
        publicURL
      }
    }
  `);
